import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MediaLibraryIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M7 15l4.5-6 3.5 4.51 2.5-3.01L21 15z"
      fill="currentColor"
    />
  </svg>
);

MediaLibraryIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MediaLibraryIcon);
